import React from 'react'
import { t } from 'i18next'
import { Badge, Icon, IconSize } from '@awell-health/design-system'
import { Activity, DataPointValueType, FormActivityDataPoint } from '../../../../generated/types-orchestration'
import { ExpandableContent } from '../../ExpandableContent'
import { mapFieldTypeIcon } from '../../ExtensionActivityDetail/tabs/mapFieldTypeIcon'

interface Props {
  activity: Activity
  data_points: Array<FormActivityDataPoint>
}

export const SavedTab: React.FC<Props> = ({ activity, data_points }) => {
  const formatDataPointValue = (value: string, valueType: any) => {
    // right now we only need to format boolean values
    // but can add more formats here
    if (valueType.toLowerCase() === 'boolean') {
      return value === '0' ? 'false' : 'true'
    }
    return value
  }

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col gap-2">
        <div className="text-lg font-medium text-gray-900">Data points saved from answers</div>
        <div className="text-base text-slate-500">
          {data_points.length > 0
            ? t('activityfeed:form_saved_data_points', {
                count: data_points.length
              })
            : t('activityfeed:form_no_data_points')}
        </div>
      </div>

      {data_points.length > 0 && (
        <div className="flex flex-col gap-2 w-full">
          {data_points.map(({ key, value, valueType }) => (
            <div key={key} className="rounded-xl border p-3">
              <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-900">Saved in</div>
                  <Badge size={null} variant="success">
                    <Icon
                      icon={mapFieldTypeIcon(valueType.toUpperCase() as DataPointValueType)}
                      size={IconSize.xxs}
                      className="mr-1"
                    />
                    {key}
                  </Badge>
                </div>
                <ExpandableContent content={formatDataPointValue(value, valueType)} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
